import axios from 'axios'
import React, { Component } from 'react'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import moment from 'moment'
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
export default class ViewImsNewFormsStage2 extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: {},
            listOfAuditReport: {
                auditreportURL: ""
            },
            uploadStatus: true,
            orgcode: props.match.params.orgcode,
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uplodedAuditReportUrl: "",
            submitStatus: false,
            isLoading:false
        }
        this.auditReportInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { orgcode: props.match.params.orgcode || 0 };
    }
    componentDidMount() {
       const api=APIURL + '/api/stagetwo/get/stagetwodata/' + this.state.orgcode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
            .then(res => {
                console.log("data", res.data.response)
                this.setState({ data: res.data.response })
                if (this.state.data.auditreporturl) {
                    this.setState({ uplodedAuditReportUrl: this.state.data.auditreporturl })

                    this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block", downloadbuttonStatus: "none" })

                }
                else if (!this.state.data.auditreporturl) {
                    this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", downloadbuttonStatus: "block" })
                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);
    
                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                   // alert("if")
                    this.setState({isLoading:true})
                }
            })
    }
    handleRoute = () => {
        window.location.href = "/" + localStorage.getItem("role") + "/auditreport/" + this.state.orgcode
    }
    downloadPDF = () => {
        return axios.get(APIURL + '/api/generatepdf/get/auditreportpdf/' + this.state.orgcode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.orgcode + '- Audit Report' + `.pdf`
                link.click()
            })
    }
    generateAuditReport = () => {
        var jsonRequest = {
            orgCode: this.state.orgcode,
            auditreporturl: this.state.listOfAuditReport.auditreportURL,
        }
        console.log("json", jsonRequest)
        axios.patch(APIURL + "/api/stagetwo/patch/auditreporturl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    this.setState({ uploadStatus: true })
                    ToastInstance('Success', 'Audit Report Uploaded')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })


    }
    removeDoc = () => {
        var tempData = this.state.listOfAuditReport;
        tempData.auditreportURL = ""
        this.setState({ listOfAuditReport: tempData, uploadStatus: true });
    }
    handleauditReport = (event) => {
        event.preventDefault();
        let newArr = this.auditReportInput.current.files[0];
        this.handleUpload(newArr);
    }
    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }
    removeUplodedDoc = () => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", uplodedAuditReportUrl: "", uploadStatus: true })

                }
            })
    }
    handleUpload = (file) => {
        S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                var tempData = this.state.listOfAuditReport;
                tempData.auditreportURL = data.location
                var docType = this.checkFileExtension(data.location)
                this.setState({ listOfAuditReport: tempData, showFile: docType, uploadStatus: false });
            })
            .catch(err => console.error(err))
    };
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link", link)
        link.href = this.state.uplodedAuditReportUrl
        window.open(link)


    }
    render() {
        console.log("length", this.state.data === null)
        const FileAttendancesheet = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.listOfAuditReport.auditreportURL} style={{ width: '80px', height: '80px' }} />
                    <span>
                        <h6 onClick={() => this.removeDoc('auditreportURL')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                    <>
                        <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} />
                        <span>
                            <h6 onClick={() => this.removeDoc('auditreportURL')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                        </span>
                    </>
                    :
                    <>
                        <input type='file' ref={this.auditReportInput} onChange={this.handleauditReport} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "4rem", paddingTop: "1rem", paddingRight: "6rem" }}>
                                        <div className="row">
                                            <div className="col-sm-12">

                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of the Organization</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Address</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.address}</p>
                                                    </div>

                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Client Code</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.clientcode}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Site Address (If any)</label>
                                                    <div className="col-sm-3">
                                                        <p> {this.state.data.siteofaddress}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">No.of Employees</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.effectiveNoEmpToBeAudited} </p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact Person</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.contactPersonName}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Email id</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.email}</p>
                                                    </div>
                                                  
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">IAF Code / NACE CODE</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.nabcbcodeName}  </p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Contact No</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.mobile}  </p>
                                                    </div>


                                                </div>
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.scope}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Non Applicable Requirements</label>
                                                    <div className="col-sm-3">
                                                        <p> {this.state.data.nonapprequirements} </p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Type of Audit(S)</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.typeofauditonAuditReport }</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Significant Changes(if any),Since last audit that affects QMS</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.significantchanges} </p>
                                                    </div>

                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date of Audit</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofaudit).format("DD-MMM-YYYY")}   </p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Place of the Audit</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.placeofaudit} </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Brief about the organization</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.briefaboutorg}   </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Any Deviation in the Audit Plan and Reason(if any)</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.anydeviationinauditplan}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Any Significant issue impacting on the Audit Programme</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.anysignificantissue}   </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Any unresolved issues(if identified)</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.anyunresolved}  </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Verification of effectiveness of NC / Concerns closure of Stage 1 Audit(If any)</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.verificationofeffectiveness}   </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Criteria of Audit</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.criteriaofaudit}  </p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize mt-3">Objective of Audit</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.objectiveofaudit} </p>
                                                    </div>
                                                </div>
                                                {/* <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of the Process</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.nameofprocess}   </p>
                                                        </div>
                                                        <label htmlFor="staticEmail" className="col-sm-3 labelsize">Process Owner</label>
                                                        <div className="col-sm-3">
                                                            <p>{this.state.data.processowner}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <label htmlFor="staticEmail" className="col-sm-3 mt-3 labelsize">Details</label>
                                                        <div className="col-sm-9  mt-3">
                                                            <p dangerouslySetInnerHTML={{ __html: this.state.data.details }}></p>
                                                            {/* <p>{this.state.data.details}</p> 
                                                        </div>
                                                    </div> */}
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize mt-3">Audit Findings</label>
                                                    {
                                                        this.state.data && this.state.data.processAuditReportDetails && this.state.data.processAuditReportDetails.length > 0 ?
                                                            this.state.data.processAuditReportDetails.map((item, index) => {
                                                                return (
                                                                    <div className="mt-4">
                                                                        <table key={index}>
                                                                            <tr >
                                                                                <td style={{width:"20%"}}> Name Of Process </td>
                                                                                <td>{item.nameofprocess}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{width:"20%"}}>Process Owner </td>
                                                                                <td>{item.processowner}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{width:"20%"}} >Reference</td>
                                                                                <td colSpan="3">{item.reference}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{width:"20%"}}>Details</td>
                                                                                <td colSpan="3" dangerouslySetInnerHTML={{ __html: item.details }}></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{width:"20%"}}>Auditor comments on</td>
                                                                                <td colSpan="3">{item.comments}</td>



                                                                            </tr>
                                                                            <tr>
                                                                                <td>Clauses Details</td>
                                                                                <td colSpan="3">
                                                                                  

                                                                                                    <table className="table ">
                                                                                                        <thead >
                                                                                                            <tr>

                                                                                                                <td scope="col" className="text-center" style={{ "width": "180px" }}>Clause </td>
                                                                                                                <td scope="col" className="text-center" style={{ "width": "120px" }}> Observation</td>
                                                                                                            </tr> 
                                                                                                            </thead>
                                                                                                            {
                                                                                        item.clauseWiseObservation ?
                                                                                            item.clauseWiseObservation.map((subitem, subindex) => {
                                                                                                return (
                                                                                                        <tbody key={subindex}>


                                                                                                            <tr>
                                                                                                                <td style={{ "width": "60px" }}>{subitem.clauseNo}</td>
                                                                                                                <td style={{ "width": "120px" }}>{subitem.Observation}</td>


                                                                                                            </tr>

                                                                                                        </tbody>
                                                                                                          )
                                                                                                        })
                                                                                                        :
                                                                                                        <>No Nace Code data addded</>
                                                                                                }
                                                                                                    </table>

                                                                                              

                                                                                </td>



                                                                            </tr>

                                                                        </table>
                                                                        <br />

                                                                    </div>
                                                                )
                                                            }
                                                            ) : <>No Data Found</>
                                                    }
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-3 labelsize">Auditor Team Observation & Nonconformity</label>
                                                    <div className="col-sm-9  mt-3">
                                                        <p dangerouslySetInnerHTML={{ __html: this.state.data.auditorteamObservation }}></p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-3 labelsize">Nonconformity if any</label>
                                                    <div className="col-sm-9  mt-3">
                                                        <p dangerouslySetInnerHTML={{ __html: this.state.data.noncom }}></p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">A. Stage of audit</label>
                                                    <div className="col-sm-9">{this.state.data.stageofaudit === 'other' ? this.state.data.otherstageofaudit : this.state.data.stageofaudit} </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">B. Recommendation</label>
                                                    <div className="col-sm-9">{this.state.data.recommendations === 'other' ? this.state.data.otherrecommendationsOptions : this.state.data.recommendations} </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-3 labelsize">C.Reason</label>
                                                    <div className="col-sm-9  mt-3">
                                                        {

                                                            this.state.data && this.state.data.reasons && this.state.data.reasons.length > 0 ?
                                                                this.state.data.reasons.map((item, index) => {

                                                                    return (
                                                                        <div key={index}>{item !== "" ? index + 1 + "." : ""}  {item !== "" ? item : ""} </div>
                                                                    )
                                                                }
                                                                ) :
                                                                <>No Reasons added </>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-3 labelsize">Proposed Audit Date for Surveillance Audit</label>
                                                    {
                                                        this.state.data.proposedAuditDateforSurveillanceAudit === null ? "-"
                                                   : <div className="col-sm-9  mt-3">{moment(this.state.data.proposedAuditDateforSurveillanceAudit).format("DD-MMM-YYYY")}</div>
                                              
                                              
                                                }      </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-3 labelsize">Summary</label>
                                                    <div className="col-sm-9  mt-3">
                                                        <p dangerouslySetInnerHTML={{ __html: this.state.data.summary }}></p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 mt-3 labelsize">Sign Off Date </label>
                                                    <div className="col-sm-9  mt-3">{
                                                        this.state.data.signofDate === null ?
                                                        "-"
                                                        :

                                                       moment(this.state.data.signofDate).format("DD-MMM-YYYY")}</div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize mt-3">IQCPL Report Submission Name of Auditor</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.teamleaderName} </p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize mt-3">Client Name for Acceptance of Report and Designation</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.contactPersonName}, {this.state.data.position}  </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <hr className="mt-4" />
                                            <div className="row ">
                                                <div className="col-sm-5 text-dark">
                                                    <h5> Download Audit Report PDf</h5>
                                                </div>
                                                <div className="col-sm-7 mb-3" style={{ textAlign: "right" }}>
                                                    <button type="submit" className="btn btn-primary" onClick={() => this.downloadPDF()} >Download</button>
                                                </div>
                                                <hr />
                                            </div>
                                            {/* <div className="row">
                                        <div className="col-sm-10"></div>
                                        <div className="col-sm-2">
                                            <button type="submit" className="btn btn-primary float-right" onClick={() => this.downloadPDF()} >Download</button>
                                        </div>
                                    </div> */}
                                        </div>
                                        {
                                            localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                ""
                                                :
                                                <div className="upload" style={{ display: this.state.uploadDocumentStatus }}>
                                                    <div >

                                                        <div className="row mt-4">
                                                            <hr className="mt-4" />
                                                            <div className="col-sm-6 text-dark ">
                                                                <h5>Upload Audit Report Sheet</h5>
                                                            </div>
                                                            <hr />


                                                            <div>
                                                                <div className="row mt-5" >
                                                                    <div className="col-sm-4 "><label htmlFor="staticEmail" className="labelsize" >Upload Audit Report Sheet</label></div>
                                                                    <div className="col-sm-6">
                                                                        {
                                                                            this.state.listOfAuditReport.auditreportURL !== "" ?
                                                                                <FileAttendancesheet />
                                                                                :
                                                                                <>
                                                                                    <input type='file' ref={this.auditReportInput} onChange={this.handleauditReport} />
                                                                                    <br></br>

                                                                                </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm-10" />
                                                                <button type="button" className="btn btn-sm btn-success col-sm-2" onClick={() => this.generateAuditReport()} disabled={this.state.uploadStatus}>Upload</button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                        <div style={{ display: this.state.uploadedDocumentStatus }}>
                                            <div className="row mt-5" >
                                                <hr className="mt-4" />
                                                <div className="col-sm-6 text-dark ">
                                                    <h5>Uploaded Audit Report</h5>
                                                </div>
                                                <hr />
                                                <div className="col-sm-4">

                                                    <label className="mt-4 labelsize">
                                                        Uploaded Audit Report
                                                    </label>

                                                </div>
                                                <div className="col-sm-6">
                                                    {
                                                        this.state.uplodedAuditReportUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                            <>
                                                                <img className="img-fluid" src={this.state.uplodedAuditReportUrl} style={{ width: '80px', height: '80px' }} onClick={() => this.downloadSignedPdf()} />
                                                                {
                                                                    localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                        ""
                                                                        :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('masterAgreementUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                }


                                                            </>
                                                            :
                                                            this.state.uplodedAuditReportUrl.match(/\.(pdf)$/) ?
                                                                <>
                                                                    <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadSignedPdf()} />
                                                                    {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                            ""
                                                                            :
                                                                            <span>
                                                                                <h6 onClick={() => this.removeUplodedDoc('masterAgreementUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                            </span>
                                                                    }
                                                                </>

                                                                :
                                                                ""
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                        {
                                            localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?

                                                !this.state.uplodedAuditReportUrl ?
                                                    <>


                                                        <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>

                                                    </>

                                                    :
                                                    ""
                                                :
                                                ""

                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                {
                                    localStorage.getItem("userRole") === "Management" || localStorage.getItem("userRole") === "Accounts" ?
                                        ""
                                        :
                                        <div className="row">
                                            <div className="col-lg-11"></div>
                                            <div className="col-lg-1" style={{ marginBottom: "10PX" }}>

                                                <button type="submit" className="btn btn-primary" onClick={() => this.handleRoute()}>Edit</button>

                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </section>
                </div>
            </div>



        )
    }
}
